import { Checkbox, FormControlLabel, Grid } from '@material-ui/core';
import React, { useContext, useEffect } from 'react';
import * as Yup from 'yup';

import CheckoutTemplate from '../../components/checkout/CheckoutTemplate';
import CheckoutForm from '../../components/checkout/CheckoutForm';
import {
  CheckoutContext,
  Environments,
  FlowsOptions,
  ICheckoutState,
  SourceOptions,
} from '../../store/CheckoutContext';

import './Checkout.css';
import { useLocation } from 'react-router-dom';

interface Props {
  paymentElement: React.ReactElement;
  validationSchema: Yup.BaseSchema;
  paymentHandler: () => void;
  state: ICheckoutState;
  setState: React.Dispatch<React.SetStateAction<{ [key: string]: any }>>;
}

const CheckoutWrapper: React.FC<Props> = props => {
  const { setErrors, setLoading, setSourceOptions } = useContext(CheckoutContext);
  const { paymentElement, validationSchema, paymentHandler, state, setState } = props;
  const location = useLocation();
  const { setFlow } = useContext(CheckoutContext);

  useEffect(() => {
    setErrors({});
  }, []);

  useEffect(() => {
    if (location.pathname === '/terminal') {
      setSourceOptions(SourceOptions.terminal);
    }
  }, []);

  useEffect(() => {
    if (location.pathname === '/checkout-iframe-without-order-id') {
      setFlow(FlowsOptions.withoutOrderId);
    }
  }, []);

  async function handleCheckout(environment: Environments) {
    // (window as any)?.UIWidget?.InitUi({ orderSessionKey: '4CE65C9C-0099-40A1-8357-70CB5F4505B4' });
    // return;
    //
    // // FIXME
    // // eslint-disable-next-line no-unreachable
    const isValid = await validateSate();
    if (!isValid) {
      return;
    }

    setLoading(true);
    paymentHandler();
  }

  async function validateSate() {
    return await validationSchema
      .validate(state, { abortEarly: false })
      .then(() => {
        setErrors({});
        return true;
      })
      .catch(err => {
        const newErrors = {};
        err?.inner?.forEach((e: any) => {
          // @ts-ignore
          newErrors[e.path] = e.message;
        });
        setErrors(newErrors);
        return false;
      });
  }

  return (
    <CheckoutTemplate handleCheckout={handleCheckout}>
      <CheckoutForm state={state} setState={setState}>
        <Grid container spacing={3}>
          <div id="iframe-container" />
          {paymentElement}
          <Grid item xs={12}>
            <FormControlLabel
              control={<Checkbox color="secondary" name="saveCard" value="yes" />}
              label="Remember credit card details for next time"
            />
          </Grid>
        </Grid>
      </CheckoutForm>
    </CheckoutTemplate>
  );
};

export default CheckoutWrapper;
